import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PROMOTION_CAMPAIGN_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createPromotionCampaignAction = createAsyncThunk(
    'price/createPromotionCampaignAction',
    async (form, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(PROMOTION_CAMPAIGN_PATH, form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createPromotionCampaignSlice = createSlice({
    name: 'createPromotionCampaignSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createPromotionCampaignAction.pending, () => STATE__API__STARTED);
        builder.addCase(createPromotionCampaignAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createPromotionCampaignAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createPromotionCampaignState = (state) => state.price.createPromotionCampaign;
export default createPromotionCampaignSlice.reducer;
